import Customer from 'models/Customer';
import { actions as userActions } from 'redux/domain/User';

/**
 * Log any changes to the customer in sessionStorage.
 */
const customerWatcher = store => {
	const { user } = store.getState();
	const customer = user.get('customer');
	sessionStorage.setItem('customer', customer.serialize());
};

/**
 * Handle any initialization needed by our store.
 * @param {Redux Store} store
 */
const initStore = store => {
	store.subscribe(() => customerWatcher(store));
	// The customer whether they are guests or not need to be persisted between refreshes.
	// Session storage goes away when the tab is closed.
	const persistedCustomer = sessionStorage.getItem('customer');
	const customer = new Customer();
	if (persistedCustomer != null) {
		customer.deserialize(persistedCustomer);
	}
	store.dispatch(userActions.login(customer));
};

export default initStore;
